import { ToasterType } from '@clickcease/cc-client-components-lib/dist/types/ToasterTypes'
import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { queryClient } from 'Lib/react-query'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useTranslation } from 'react-i18next'
import { useGetErrorText } from 'Utils/errorText'

type Params = {
  userId: number
  accounts: number[]
}

export type VerifyInviteResponse = {
  data: {
    code: string
    userId: number
    email: string
    name: string
    accountId: number
    accountName: string
    role: string
  }
}

const acceptPendingInvitation = ({ userId, accounts }: Params) =>
  request<VerifyInviteResponse>({
    url: `users/${userId}/invite/accept`,
    method: 'PUT',
    data: { accounts },
    hideErrorToaster: true,
  })

export const useAcceptPendingInvitation = (callbacks?: {
  onSuccess?: () => void
  onError?: (error: unknown) => void
}) => {
  const { t } = useTranslation('auth')
  const { showToaster } = useAppStore()
  const { getErrorText } = useGetErrorText()

  return useMutation(acceptPendingInvitation, {
    onSuccess: async () => {
      callbacks?.onSuccess?.()
      const toaster = {
        type: 'success' as ToasterType,
        text: t('login.invitation_success_please_authenticate'),
      }
      showToaster(toaster.text, toaster.type)
      await queryClient.invalidateQueries(['userAccounts'])
    },
    onError: (error) => {
      const toaster = {
        type: 'failure' as ToasterType,
        text: getErrorText(error) || 'Something went wrong',
      }
      showToaster(toaster.text, toaster.type)
      callbacks?.onError?.(error)
    },
  })
}
